export default __webpack_public_path__ + "static/media/logo.9a5f9313.png";